import { render } from "./TopSectionWrapper.vue?vue&type=template&id=6a6ed22e&scoped=true"
import script from "./TopSectionWrapper.vue?vue&type=script&lang=js"
export * from "./TopSectionWrapper.vue?vue&type=script&lang=js"

import "./TopSectionWrapper.vue?vue&type=style&index=0&id=6a6ed22e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6ed22e"]])

export default __exports__